import styled from 'styled-components';

// Cards de resumo das telas do menu Cobranca. Mesma linguagem visual do BICard
// de components/Banking/Cards, para nao criar um segundo estilo de card no
// sistema.
export const CardsContainer = styled.div.attrs({})`
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
  /* Em tela estreita os cards quebram em vez de espremer o valor. */
  @media (max-width: 900px) {
    flex-wrap: wrap;
  }
`;

export const Card = styled.div.attrs({})`
  /* flex: 1 com base 0 divide a linha em partes iguais, independente do
     tamanho do texto de cada card. */
  flex: 1 1 0;
  min-width: 150px;
  background: white;
  padding: 10px 15px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  border-left: 4px solid ${(props) => props.$color || '#2670d1'};
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition:
    box-shadow 0.2s ease,
    background 0.2s ease;

  /* Card que liga um filtro. O ativo fica com a cor do proprio card, para o
     operador ver de onde veio o recorte da listagem. */
  ${(props) =>
    !props.$clickable
      ? ''
      : `
    cursor: pointer;
    user-select: none;
    &:hover {
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.12);
    }
    &:focus-visible {
      outline: 2px solid ${props.$color || '#2670d1'};
      outline-offset: 2px;
    }
  `}
  ${(props) =>
    !props.$active
      ? ''
      : `
    background: ${props.$color || '#2670d1'}12;
    border-color: ${props.$color || '#2670d1'};
    box-shadow: 0 0 0 1px ${props.$color || '#2670d1'} inset;
  `}
`;

export const CardLabel = styled.div.attrs({})`
  font-size: 12px;
  color: #718096;
  text-transform: uppercase;
  margin-bottom: 4px;
`;

export const CardValor = styled.div.attrs({})`
  font-size: 18px;
  font-weight: bold;
  color: #2d3748;
`;

export const CardRodape = styled.div.attrs({})`
  font-size: 12px;
  margin-top: 4px;
  color: #4a5568;
`;
